// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Images
import pattern from "assets/images/illustrations/pattern-tree.svg";
import mpesaLogo from "assets/images/logos/m-pesa.png";

function MasterCard({ color, currentInfo }) {
  return (
    <Card
      sx={({
        palette: { gradients },
        functions: { linearGradient },
        boxShadows: { xl },
      }) => ({
        background: gradients[color]
          ? linearGradient(gradients[color].main, gradients[color].state)
          : linearGradient(gradients.dark.main, gradients.dark.state),
        boxShadow: xl,
        position: "relative",
        width: 510,
        height: 230,
      })}
    >
      <MDBox
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        opacity={0.2}
        sx={{
          backgroundImage: `url(${pattern})`,
          backgroundSize: "cover",
        }}
      />
      <MDBox position="relative" zIndex={2} p={2}>
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <MDBox color="white" p={1} lineHeight={0} display="inline-block">
            <Icon fontSize="default">contactless</Icon>
          </MDBox>
          <MDTypography
            variant="h5"
            color="white"
            fontWeight="medium"
            sx={{ mt: 3, mb: 2, pb: 1 }}
          >
            {currentInfo?.method}
          </MDTypography>
        </MDBox>
        <MDBox mr={3} mb={2} lineHeight={1} display="flex" alignItems="center">
          <MDTypography
            variant="button"
            color="white"
            fontWeight="regular"
            opacity={0.8}
          >
            {currentInfo?.method === "MPESA"
              ? "Paybill Number: "
              : currentInfo?.method === "CHEQUE"
              ? "Bank Account: "
              : currentInfo?.method === "BANK TRANSFER"
              ? "Bank Account: "
              : currentInfo?.method === "FINANCING"
              ? "Credit: "
              : "Account: "}
          </MDTypography>
          <MDTypography
            variant="h5"
            color="white"
            ml={3}
            fontWeight="medium"
            textTransform="capitalize"
          >
            {currentInfo?.account}
          </MDTypography>
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDBox display="flex" alignItems="center">
            <MDBox lineHeight={1}>
              <MDTypography
                variant="button"
                color="white"
                fontWeight="regular"
                opacity={0.8}
              >
                Account Name:
              </MDTypography>
              <MDTypography variant="h5" color="white" fontWeight="medium">
                {currentInfo?.subAccount}
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox display="flex" justifyContent="flex-end" width="20%">
            {currentInfo?.method === "MPESA" ? (
              <MDBox
                component="img"
                src={mpesaLogo}
                alt="m-pesa"
                width="60%"
                mt={1}
              />
            ) : currentInfo?.method === "CHEQUE" ? (
              <MDBox color="white" p={1} lineHeight={0} display="inline-block">
                <Icon fontSize="large">account_balance</Icon>
              </MDBox>
            ) : currentInfo?.method === "BANK TRANSFER" ? (
              <MDBox color="white" p={1} lineHeight={0} display="inline-block">
                <Icon fontSize="large">account_balance</Icon>
              </MDBox>
            ) : currentInfo?.method === "FINANCING" ? (
              <MDBox color="white" p={1} lineHeight={0} display="inline-block">
                <Icon fontSize="large">credit_card</Icon>
              </MDBox>
            ) : (
              <MDBox color="white" p={1} lineHeight={0} display="inline-block">
                <Icon fontSize="large">paid</Icon>
              </MDBox>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of MasterCard
MasterCard.defaultProps = {
  color: "dark",
};

// Typechecking props for the MasterCard
MasterCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
};

export default MasterCard;
